import { render, staticRenderFns } from "./x-confirm-dialog.vue?vue&type=template&id=51b7d1a6"
import script from "./x-confirm-dialog.ts?vue&type=script&lang=js&external"
export * from "./x-confirm-dialog.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports